module.exports = __webpack_public_path__ + "voip-chevron.svg?bbab537bff9cdf86591c1f416fa934cb";